<template>
  <div>
    <card-seplag
      titulo="Anexe/Envie o documento gerado na Declaração Anual de Pessoa Física do corrente ano, contendo o quadro de Identificação, Dependentes e Bens e Direitos."
    >
      <Rotulo nome="" cols="12" class="rotulo">
        <div class="cardButtonFile">
          <FileUpload
            name="file[]"
            accept="application/pdf"
            :maxFileSize="3028000"
            chooseLabel="Quadros da Declaração de Imposto de Renda"
            uploadLabel="Enviar"
            cancelLabel="Cancelar"
            :fileLimit="1"
            :previewWidth="60"
            invalidFileSizeMessage="{0}: Tamanho de arquivo inválido, o tamanho do arquivo deve ser menor que 3MB."
            invalidFileLimitMessage="Número máximo de arquivo excedido, o limite é {0} no máximo"
            @uploader="onUploadIR"
            :customUpload="true"
            :disabled="!isPermitirEditar"
            v-if="listaArquivoIR.length == 0"
          >
            <template #empty>
              <div class="display-flex-center">
                <i class="pi pi-download icon-arraste"></i>
                <p class="texto-arraste">Escolha o arquivo ou arraste aqui</p>
              </div>
            </template>
          </FileUpload>

          <DataTable
            :value="listaArquivoIR"
            class="p-datatable-responsive-demo p-datatable-gridlines"
            v-if="listaArquivoIR.length > 0"
            :rowClass="rowClass"
          >
            <Column
              field="arquivo.tipoExtensaoArquivo"
              header="Extensão"
              headerStyle="width: 8rem"
              bodyClass="columnAlign"
            >
              <template #body="slotProps">
                <span class="p-column-title">Extensão:</span>
                {{
                  (slotProps.data.arquivo.tipoExtensaoArquivo || "").toUpperCase()
                }}
              </template>
            </Column>

            <Column
              field="arquivo.descArquivo"
              header="Arquivo"
              bodyClass="columnAlign"
            >
              <template #body="slotProps">
                <span class="p-column-title">Arquivo:</span>
                <span>{{ slotProps.data.arquivo.descArquivo }}</span>
              </template>
            </Column>

            <Column
              headerStyle="width: 8em"
              bodyClass="columnAlign"
              header="Ação"
            >
              <template #body="slotProps">
                <Button
                  type="button"
                  icon="pi pi-replay"
                  @click="changeArquivo(slotProps.data)"
                  class="p-button-raised p-button-warning"
                  style="margin-right: 0.5rem"
                  :disabled="!isPermitirEditar"
                />

                <Button
                  type="button"
                  icon="pi pi-print"
                  @click="download(slotProps.data.arquivo.idenArquivo)"
                  class="p-button-raised"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </Rotulo>

      <div class="p-col-12" />

      <!--<Rotulo
        nome="Anexar a primeira página do arquivo de Recibo de Envio da declaração"
        cols="12"
        class="rotulo"
        requerido
      >
        <FileUpload
          name="file[]"
          accept="application/pdf"
          :maxFileSize="2028000"
          chooseLabel="Recibo de Imposto de Renda"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          :fileLimit="1"
          :previewWidth="60"
          invalidFileSizeMessage="{0}: Tamanho de arquivo inválido, o tamanho do arquivo deve ser menor que 2MB."
          invalidFileLimitMessage="Numero maximo de arquivo excedido, o limite é {0} no máximo"
          @uploader="onUploadDeclaracao"
          :customUpload="true"
          v-if="listaArquivoRecibo.length == 0"
        >
          <template #empty>
            <div class="display-flex-center">
              <i class="pi pi-download icon-arraste"></i>
              <p class="texto-arraste">Escolha o arquivo ou arraste aqui</p>
            </div>
          </template>
        </FileUpload>

        <DataTable
          :value="listaArquivoRecibo"
          class="p-datatable-responsive-demo p-datatable-gridlines"
          v-if="listaArquivoRecibo.length > 0"
          :rowClass="rowClass"
        >
          <Column
            field="arquivo.tipoExtensaoArquivo"
            header="Extensão"
            headerStyle="width: 8rem"
            bodyClass="columnAlign"
          >
            <template #body="slotProps">
              <span class="p-column-title">Extensão:</span>
              {{ slotProps.data.arquivo.tipoExtensaoArquivo }}
            </template>
          </Column>

          <Column
            field="arquivo.descArquivo"
            header="Arquivo"
            bodyClass="columnAlign"
          >
            <template #body="slotProps">
              <span class="p-column-title">Arquivo:</span>
              {{ slotProps.data.arquivo.descArquivo }}
            </template>
          </Column>

          <Column
            headerStyle="width: 8em"
            bodyClass="columnAlign"
            header="Ação"
          >
            <template #body="slotProps">
              <Button
                type="button"
                icon="pi pi-replay"
                @click="changeArquivo(slotProps.data)"
                class="p-button-raised p-button-warning"
                style="margin-right: 0.5rem"
              />

              <Button
                type="button"
                icon="pi pi-print"
                @click="download(slotProps.data.arquivo.idenArquivo)"
                class="p-button-raised"
              />
            </template>
          </Column>
        </DataTable>
      </Rotulo> -->

      <div class="p-col-12">
        <div class="avisos">
          <p>Apenas arquivos PDF de no máximo 3mb cada.</p>
        </div>
      </div>

      <div class="p-col p-md-6">
        <div class="p-grid" v-if="permiteExecutarAcao">
          <div class="p-col-12 p-md-6">
            <Button
              label="Finalizar Declaração"
              class="p-button-raised p-button-rounded p-button-success"
              @click="abreDialogo()"
              :disabled="!isPermitirEditar"
            />
          </div>

          <div class="p-col-12 p-md-6">
            <Button
              class="p-button-raised p-button-rounded p-button-danger"
              label="Excluir Declaração"
              @click="abreDialogoExclusao()"
              :disabled="!isPermitirEditar"
            ></Button>
          </div>
        </div>
      </div>

      <Dialog
        :header="'Confirmação de Envio'"
        :visible.sync="dialogConfirmacao"
        class="dialogo-termo-aceite"
        :contentStyle="{ width: '30vw' }"
        :modal="true"
      >
        <div class="confirmation-content texto-centro">
          <span
            >Você tem certeza que gostaria de finalizar esta declaração?</span
          >
        </div>
        <template #footer>
          <Button
            label="Não"
            icon="pi pi-times"
            @click="fecharDialogo"
            class="p-button-text"
          />
          <Button
            label="Sim"
            icon="pi pi-check"
            @click="salvarDeclaracao()"
            class="p-button-text"
            autofocus
            :disabled="!isPermitirEditar"
          />
        </template>
      </Dialog>

      <Dialog
        :header="'Confirmação de Exclusão'"
        :visible.sync="dialogConfirmacaoExclusao"
        class="dialogo-termo-aceite"
        :contentStyle="{ width: '30vw' }"
        :modal="true"
      >
        <div class="confirmation-content texto-centro">
          <span>
            Você tem certeza que deseja EXCLUIR essa declaração? Obs: O
            Protocolo atual será excluído, você terá que realizar uma nova
            declaração para gerar um novo Protocolo.</span
          >
        </div>
        <template #footer>
          <Button
            label="Não"
            icon="pi pi-times"
            @click="fecharDialogoExclusao"
            class="p-button-text"
          />
          <Button
            label="Sim"
            icon="pi pi-check"
            @click="excluirDeclaracao"
            class="p-button-text"
            autofocus
            :disabled="!isPermitirEditar"
          />
        </template>
      </Dialog>

      <Dialog
        :header="tituloAlterarArquivo"
        :visible.sync="isShowDialogAlterarArquivo"
        class="dialogo-termo-aceite"
        :modal="true"
      >
        <FileUpload
          name="file[]"
          accept="application/pdf"
          :maxFileSize="2028000"
          :chooseLabel="changeFileLabel"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          :fileLimit="1"
          :previewWidth="60"
          invalidFileSizeMessage="{0}: Tamanho de arquivo inválido, o tamanho do arquivo deve ser menor que 1MB."
          invalidFileLimitMessage="Numero maximo de arquivo excedido, o limite é {0} no máximo"
          @uploader="onUploadChangeArquivo"
          :customUpload="true"
        >
          <template #empty>
            <div class="display-flex-center">
              <i class="pi pi-download icon-arraste"></i>
              <p class="texto-arraste">Escolha o arquivo ou arraste aqui</p>
            </div>
          </template>
        </FileUpload>
      </Dialog>
    </card-seplag>
    <CardExibirPDF
      :tamanhoTela="'85,vw'"
      :alturaTela="'120,vh'"
      :pdfElement="dadosRelatorioBase64"
      v-model="isExibirPDF"
      :tituloTela="tituloPDF"
      v-if="isExibirPDF"
    />
  </div>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl, printToast } from "@/config/global";
import CardExibirPDF from "@/template/CardExibirPDF";

export default {
  name: "declaracaoArqFederal",
  components: { CardSeplag, Rotulo, CardExibirPDF },
  props: {
    mode: {
      type: String,
      require: true,
    },
    pFormData: {
      type: Object,
      require: true,
    },
    isPermitirEditar: {
      type: Boolean,
      require: true,
    },
  },
  data: function () {
    return {
      dialogConfirmacao: false,
      dialogConfirmacaoExclusao: false,
      listaArquivoIR: [],
      listaArquivoRecibo: [],
      dadosRelatorioBase64: "",
      isExibirPDF: false,
      tituloPDF: " ",
      tituloAlterarArquivo: "",
      isShowDialogAlterarArquivo: false,
      formData: this.pFormData,
      changeArquivoObj: null,
      idenContaAcesso: 0,
      changeFileLabel: "",
      permiteExecutarAcao: this.pFormData.tipoDeclaracao != "NAO_INFORMADO",
    };
  },
  methods: {
    carregarDados() {
      this.formData = { ...this.pFormData };
      this.listaArquivoIR = this.formData.arquivosDeclaracao.filter(
        (item) =>
          item.tipoDocDeclaracaoBem.tipoDocumento.siglTipoDocumento ==
          "DECLARACAOBENS"
      );
      this.listaArquivoRecibo = this.formData.arquivosDeclaracao.filter(
        (item) =>
          item.tipoDocDeclaracaoBem.tipoDocumento.siglTipoDocumento ==
          "RECIBODECLBENS"
      );

      this.listaArquivoIR = this.listaArquivoIR.map((item) => {
        let aux = { ...item };
        if (aux.flagFrontAcao == "VALIDADO") {
          aux.arquivo.descArquivo = `${aux.arquivo.descArquivo} (APROVADO)`;
        } else if (aux.flagFrontAcao == "RECUSADO") {
          aux.arquivo.descArquivo = `${aux.arquivo.descArquivo} (RECUSADO - ${
            aux.listaRejeicaoArquivo
              ? aux.listaRejeicaoArquivo[0].motivoRejeicao.descMotivoRejeicao
              : ""
          })`;
        }
        return aux;
      });

      this.listaArquivoRecibo = this.listaArquivoRecibo.map((item) => {
        let aux = { ...item };

        if (aux.flagFrontAcao == "VALIDADO") {
          aux.arquivo.descArquivo = `${aux.arquivo.descArquivo} (APROVADO)`;
        } else if (aux.flagFrontAcao == "RECUSADO") {
          aux.arquivo.descArquivo = `${aux.arquivo.descArquivo} (RECUSADO - ${
            aux.listaRejeicaoArquivo
              ? aux.listaRejeicaoArquivo[0].motivoRejeicao.descMotivoRejeicao
              : ""
          })`;
        }
        return aux;
      });

      this.idenContaAcesso = this.$store.getters.getUser.contaAcesso.id;
    },

    fecharDialogo() {
      this.dialogConfirmacao = false;
    },

    abreDialogo() {
      this.dialogConfirmacao = true;
    },

    fecharDialogoExclusao() {
      this.dialogConfirmacaoExclusao = false;
    },

    abreDialogoExclusao() {
      this.dialogConfirmacaoExclusao = true;
    },

    salvarDeclaracao() {
      if (this.isPermitirEditar) {
        this.$http
          .put(
            `${baseApiUrl}/pessoaexercicios/finalizar/arquivo/${this.formData.idenPessoaExercicio}/${this.idenContaAcesso}`
          )
          .then((res) => {
            this.dialogConfirmacao = false;
            this.$emit("protocolo", { data: res.data });
          });
      }
    },
    excluirDeclaracao() {
      if (this.isPermitirEditar) {
        this.$http
          .put(
            `${baseApiUrl}/pessoaexercicios/desativar/${this.formData.idenPessoaExercicio}/${this.idenContaAcesso}`
          )
          .then((res) => {
            printToast({
              severity: "success",
              summary: "Declaração Excluída",
              detail: res.data,
            });
            this.dialogConfirmacaoExclusao = false;

            setTimeout(() => {
              this.$router.push({ path: `/${process.env.VUE_APP_BASE_URL}` });
            }, 500);
          });
      }
    },
    changeArquivo(data) {
      this.changeArquivoObj = { ...data };

      if (
        this.changeArquivoObj.tipoDocDeclaracaoBem.tipoDocumento
          .siglTipoDocumento == "DECLARACAOBENS"
      ) {
        this.changeFileLabel = "Declaração de Imposto de Renda";
      } else {
        this.changeFileLabel = "Recibo de Imposto de Renda";
      }

      this.isAlterarIR = true;
      this.tituloAlterarArquivo = `Alterar arquivo ${data.arquivo.descArquivo}`;
      this.isShowDialogAlterarArquivo = true;
    },
    onUploadIR(data) {
      if (this.isPermitirEditar) {
        let formData = new FormData();
        formData.append("file", data.files[0]);

        this.$http
          .post(
            `${baseApiUrl}/arquivodeclaracaobens/upload/declaracaobens/${this.formData.idenPessoaExercicio}/${this.idenContaAcesso}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            data.files.splice(0, data.files.length);
            this.$emit("atualizarParmArq", { arquivo: res.data });
            this.permiteExecutarAcao =
              res.data.tipoDeclaracao != "NAO_INFORMADO";
            this.listaArquivoIR = this.formData.arquivosDeclaracao.filter(
              (item) =>
                item.tipoDocDeclaracaoBem.tipoDocumento.siglTipoDocumento ==
                "DECLARACAOBENS"
            );

            this.$http
              .get(
                `${baseApiUrl}/pessoaexercicios/resumo/${this.formData.idenPessoaExercicio}`
              )
              .then((res) => {
                this.formData = res.data;
                this.carregarDados();
              });
          });
      }
    },
    onUploadDeclaracao(data) {
      if (this.isPermitirEditar) {
        let formData = new FormData();
        formData.append("file", data.files[0]);

        this.$http
          .post(
            `${baseApiUrl}/arquivodeclaracaobens/upload/recibodeclbens/${this.formData.idenPessoaExercicio}/${this.idenContaAcesso}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            data.files.splice(0, data.files.length);
            this.$emit("atualizarParmArq", { arquivo: res.data });
            this.listaArquivoRecibo = this.formData.arquivosDeclaracao.filter(
              (item) =>
                item.tipoDocDeclaracaoBem.tipoDocumento.siglTipoDocumento ==
                "RECIBODECLBENS"
            );
            // this.$http.get(`${baseApiUrl}/pessoaexercicios/resumo/${this.formData.idenPessoaExercicio}`)
            // .then((res) => {
            //     this.formData = res.data
            //     this.carregarDados()
            // })
          });
      }
    },
    onUploadChangeArquivo(data) {
      if (this.isPermitirEditar) {
        let formData = new FormData();
        formData.append("file", data.files[0]);

        this.$http
          .put(
            `${baseApiUrl}/arquivodeclaracaobens/upload/${this.changeArquivoObj.idenArquivoDeclaracaoBem}/${this.idenContaAcesso}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((res) => {
            this.$emit("atualizarParmArq", {
              arquivosDeclaracao: res.data,
              mod: "UPD",
            });
            this.carregarDados();
            data.files.splice(0, data.files.length);

            this.tituloAlterarArquivo = ``;
            this.isShowDialogAlterarArquivo = false;
          });
      }
    },
    download(idenArquivoDecaracaoBem) {
      this.$http
        .get(
          `${baseApiUrl}/arquivodeclaracaobens/download/base64/${idenArquivoDecaracaoBem}`
        )
        .then((res) => {
          this.dadosRelatorioBase64 = res.data;
          this.isExibirPDF = true;
        });
    },
    rowClass(data) {
      return data.flagFrontAcao == "VALIDADO"
        ? "arquivo-aceito"
        : data.flagFrontAcao == "RECUSADO"
        ? "arquivo-recusado"
        : null;
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style lang="scss" scoped >
#botaoFim {
  font-size: 1.5vw;
  width: 11vw;
  text-align: center;
}

.texto-centro {
  text-align: center;
}

.arquivo-federal-container {
  margin: auto auto;
}

.avisos {
  text-align: center;
  background-color: rgb(231, 232, 125); /* Yellow */
  color: #000000;
  border-radius: 12px;
  font-size: 1.142rem;
  font-weight: bold;
  // width: 50vw;
}

// @media screen and (min-width: 100rem){
//     .arquivo-federal-container{
//         margin: auto 20rem;
//     }
// }

.rotulo {
  margin: 1rem auto;
}

.columnAlign {
  text-align: center;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 60em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-row {
        display: flex;
        flex-direction: column;
      }
      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
          text-align: center !important;
          display: flex !important;

          & button {
            width: 100%;
          }
        }
      }
    }
  }
}

.icon-arraste {
  font-size: 2rem;
  margin: 1rem 1rem;
}

.display-flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>


<style>
.arquivo-aceito {
  background-color: #6cb358 !important;
}

.arquivo-aceito td,
.arquivo-recusado td {
  color: #191010;
  font-size: 1.1rem;
  font-weight: 500;
}

.arquivo-recusado {
  background-color: #ea5d5d !important;
}
</style>